import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
  query Spots ($limit: Int, $filters:[Filter]) {
    Spots: ViLabels (limit: $limit, filters: $filters) {
        ...viLabelProps
    }
  }
  ${fragments.viLabelProps}
`